import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ProjectSearchResponse} from '../models/project';
import {Observable} from 'rxjs';
import {ColorScheme, ColorSchemeResponse} from '../models/color-scheme';

export interface ColorSchemeService{
    list(projectReferenceId: number): Observable<ColorSchemeResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ColorSchemeServiceImpl implements ColorSchemeService{
    protected http = inject(HttpClient);


    list(projectReferenceId: number): Observable<ColorSchemeResponse[]> {
        return this.http.get<ColorSchemeResponse[]>(`/api/v1/color-schemes`, {
            params: {projectReferenceId}
        });
    }

}
